import { useMutation } from '@tanstack/react-query';
import { createSmartList } from 'shared/services/backend-api';
import { NewSmartList } from 'shared/types/smart-list';

export const useCreateSmartListMutation = () =>
  useMutation({
    mutationFn: (smartList: NewSmartList) => createSmartList(smartList),
  });
